import React, { useEffect, useState } from "react";
import { fetchData } from "../Components/common/utils";
import { useParams } from "react-router-dom";

const ServicesDetail = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();

    useEffect(() => {
        const fetchApiData = async () => {
            const url = "api/service/detail/" + id;
            const result = await fetchData(url);
            if (result) {
                setData(result.data);
            }
            setLoading(false);
        };
        fetchApiData();
    }, []);

    return (
        <>
            <section class="page-top-section text-center">
                <div class="container">
                    <div class="page-header">
                        <h1>Service Detail</h1>
                    </div>
                </div>
            </section>
            <section className="container my-5">
                {loading && (
                    <div
                        style={{ height: "30em" }}
                        className="mt-5 d-flex justify-content-center align-items-center"
                    >
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>)}
                <h2>{data.title}</h2>
                <p className="mt-3">{data.description}</p>
                <div dangerouslySetInnerHTML={{ __html: data.long_description }}></div>
            </section>
        </>
    );
};

export default ServicesDetail;
